export default __webpack_public_path__ + "static/media/Banned.f6a0c9ab.svg";